// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.center-blur-bg {
    position: absolute;
    top: 0; left: 0; bottom: 0; right: 0;
    backdrop-filter: blur(3px);
    z-index: 10;
    display: flex;
    align-items: center;
    justify-content: center;
}

.popup-heading {
    margin: -3px -3px 0 auto;
    font-size: 0.8rem;
    color: black;
    width: fit-content;
    padding: 2px 15px 2px 15px;
    border-radius: 4px;
}

.popup {
    border-radius: 5px;
    margin: 10px;
    border: 3px solid rgb(255, 145, 0);
    background-color: rgba(110, 63, 0, 0.836);
}

.popup > h1 {
    margin: -3px -3px 0 auto;
    font-size: 0.8rem;
    color: black;
    width: fit-content;
    padding: 2px 15px 2px 15px;
    border-radius: 4px;
    background-color: rgb(255, 153, 0);
}

.popup_internal {
    flex-grow: 1;
    padding: 10px;
    overflow: hidden;
}`, "",{"version":3,"sources":["webpack://./src/general_assets/popup.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,MAAM,EAAE,OAAO,EAAE,SAAS,EAAE,QAAQ;IACpC,0BAA0B;IAC1B,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,wBAAwB;IACxB,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,0BAA0B;IAC1B,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,kCAAkC;IAClC,yCAAyC;AAC7C;;AAEA;IACI,wBAAwB;IACxB,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,0BAA0B;IAC1B,kBAAkB;IAClB,kCAAkC;AACtC;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,gBAAgB;AACpB","sourcesContent":[".center-blur-bg {\r\n    position: absolute;\r\n    top: 0; left: 0; bottom: 0; right: 0;\r\n    backdrop-filter: blur(3px);\r\n    z-index: 10;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n.popup-heading {\r\n    margin: -3px -3px 0 auto;\r\n    font-size: 0.8rem;\r\n    color: black;\r\n    width: fit-content;\r\n    padding: 2px 15px 2px 15px;\r\n    border-radius: 4px;\r\n}\r\n\r\n.popup {\r\n    border-radius: 5px;\r\n    margin: 10px;\r\n    border: 3px solid rgb(255, 145, 0);\r\n    background-color: rgba(110, 63, 0, 0.836);\r\n}\r\n\r\n.popup > h1 {\r\n    margin: -3px -3px 0 auto;\r\n    font-size: 0.8rem;\r\n    color: black;\r\n    width: fit-content;\r\n    padding: 2px 15px 2px 15px;\r\n    border-radius: 4px;\r\n    background-color: rgb(255, 153, 0);\r\n}\r\n\r\n.popup_internal {\r\n    flex-grow: 1;\r\n    padding: 10px;\r\n    overflow: hidden;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
